import { AsoEbiTxnMeta, Transaction, TransactionCtx, TransactionStatus } from "../../types/transaction";
import { generateAPI } from "../api.generator";

export const getAsoEbiSalesHistory = generateAPI<
  {
    query: {
      transactionCtx: TransactionCtx;
      transactionStatus?: TransactionStatus.TxStatusSuccess,
      page: number;
    }
  }
, 
{
  transactionCount: number;
  transactionList: Transaction<AsoEbiTxnMeta>[];
}>("get", "transactions/all");
